export default __webpack_public_path__ + "static/media/red-heart.3874f39c.png";